import React from 'react'
import Layout from '../components/layout/Layout'
import InvestorQuizFunnel from '../components/ai-portfolio/InvestorQuizFunnel'
import NewsletterForm from '../components/newsletter/NewsletterForm'

import { Helmet } from 'react-helmet'


export default function Quiz() {
  return (
    <>
    <Helmet>
  <title>Investment Quiz for Beginners | Find Your Portfolio | Stocks With Nik</title>

  <meta 
    name="description" 
    content="Take this beginner-friendly investment quiz to discover a personalized ETF portfolio based on your goals, risk tolerance, and financial situation. Simple. Long-term focused. No hype." 
  />

  <meta 
    name="keywords" 
    content="investment quiz, beginner investing quiz, risk tolerance quiz, ETF portfolio quiz, what should I invest in, beginner stock market quiz, portfolio builder" 
  />

  <meta name="viewport" content="width=device-width, initial-scale=1" />

  {/* Open Graph (for social sharing) */}
  <meta property="og:title" content="Investment Quiz for Beginners | Stocks With Nik" />
  <meta 
    property="og:description" 
    content="Answer a few simple questions and get a personalized beginner ETF portfolio designed around your risk level and goals." 
  />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://stockswithnik.com/quiz" />
  <meta property="og:image" content="https://stockswithnik.com/og-quiz-preview.jpg" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Beginner Investment Quiz | Stocks With Nik" />
  <meta 
    name="twitter:description" 
    content="Find out what you should invest in based on your goals and risk tolerance. Built for beginner investors." 
  />
</Helmet>

          <Layout content={
            <>
             <div className='p-2 mb-5 mt-5' style={{ textAlign: "center" }}>
              <h1 className="mb-2">Build Your Personalized Beginner Portfolio</h1>
              <p
                className="text-muted"
                style={{ maxWidth: 900, margin: "0 auto" }}
              >
                  Answer a few simple questions about your goals, risk tolerance, and financial situation.
    In 5–7 minutes, you’ll get a realistic long-term investing plan designed specifically for you — no hype, no complicated strategies.
              </p>
            </div>
                <InvestorQuizFunnel />
            </>
          } />
        </>
  )
}
